import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useStore } from "../../../app/stores/store";
import { Field, Formik } from "formik";
import { toast } from "react-toastify";
import {
  MySelectInputEdicionesControl,
  valor,
  MySelectInputControl,
  MySelectInput,
  MySelectInputEnLab,
  MySelectInputEdiciones,
  MySelectInputEdicionesControll,
} from "../../../app/common/form/MySelectInput";
import { ActividadEconomicaOptions } from "../../../app/common/options/ActividadEconomicaOptions";
import { GradoAcademicoOptions } from "../../../app/common/options/GradoAcademicoOptions";
import { IdentidadCulturalOptions } from "../../../app/common/options/IdentidadCulturalOptions";
import { NacionalidadOptions } from "../../../app/common/options/NacionalidadOptions";
import { RenglonesPersonasOptions } from "../../../app/common/options/RenglonesPersonasOptions";
import { GeneroOptions } from "../../../app/common/options/GeneroOptions";/**/
import { SGPersonaFormValues, SGPersona } from '../../../app/models/SGPersona';
import { SGTDepartamentoFormValues } from "../../../app/models/SGTDepartamentos";
import { SGTMunicipioFormValues } from "../../../app/models/SGTMunicipios";
import { SGTComunidadFormValues } from "../../../app/models/SGTComunidades";
import { SGTEntidadFormValues } from "../../../app/models/SGTEntidades";
import "./SGPersonaForm_style.css";
import Footer from "../../../components/Footer";
import { InstitucionesPublicas } from "../../../app/common/options/InstitucionesPublicas";
import React from "react";
import CodigoInstitucional from "../../../components/Modals/CodigoInstitucional";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { Button, Select, ItemContent } from "semantic-ui-react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import EditIcon from "@material-ui/icons/Edit";
import "../../SGPersonas/SGPersonasMarkup.css";
import userPlaceholder from "../../../../src/images/docente-placeholder.png";
import modalRCentral from "../../../components/Portafolio/src/imgs/regional_images/home_modal_central.jpg";
import modalRPeten from "../../../components/Portafolio/src/imgs/regional_images/home_modal_peten.jpg";
import modalRegNorte from "../../../components/Portafolio/src/imgs/regional_images/home_modal_regional_norte.png";
import modalRegHuehue from "../../../components/Portafolio/src/imgs/regional_images/reg_huehuetenango.jpg";
import { calculoFechasControl } from "../../../components/Portafolio/helpers/calculoFechas";
import { Profile } from "../../../app/models/profile";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import ActualizarContraseña from "./ActualizarContraseña/ActualizarContraseña";

var municipioXdepartamentoRe: any = [],
  municipioXdepartamentoLab: any = [],
  dele: any = "",
  compas: any = "",
  inpuIns: any = "",
  inpuIns2: any = "",
  inpuIns3: any = "",
  inpuIns4: any = "",
  valores: any = "verdadf",
  valores2: any = "verdadf",
  valores3: any = "verdadf",
  valores4: any = "verdadf";

var persona: boolean = false,
  personal: any = false;

interface Props {
  ruta: string;
  profile: Profile;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: "none",
    },
    paper: {
      padding: theme.spacing(0),
    },
  })
);

export default observer(function SGPersonaForm({ ruta }: Props) {
  const [actividad, setActividad] = React.useState(false);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const history = useHistory();
  const {
    SGTComunidadStore,
    SGTMunicipioStore,
    SGTDepartamentoStore,
    SGPersonaStore,
    SGTEntidadStore,
    userStore: { user, logout, isLoggedIn, roles, loadNotificar },
    modalStore,
  } = useStore();

  const { updateSGPersona, loading, loadSGPersona, loadingInitial, dpiValido, nitValido, delegacionValido } = SGPersonaStore;
  const { loadSGTDepartamentos, SGTDepartamentoRegistry } = SGTDepartamentoStore;
  const { loadSGTMunicipios, loadSGTMunicipio, SGTMunicipioRegistry } = SGTMunicipioStore;
  const { loadSGTComunidades, SGTComunidadRegistry } = SGTComunidadStore;
  const { loadSGTEntidades, SGTEntidadRegistry } = SGTEntidadStore;
  const { id } = useParams<{ id: string }>();
  const { ac } = useParams<{ ac: any }>();

  let Departamentos: any = [];
  let Municipios: any = [];
  let Comunidades: any = [];
  let Entidades: any = [];

  const [SGPersona, setSGPersona] = useState<SGPersonaFormValues>(
    new SGPersonaFormValues()
  );
  const [SGTDepartamento, setSGTDepartamento] =
    useState<SGTDepartamentoFormValues>(new SGTDepartamentoFormValues());
  const [SGTMunicipio, setSGTMunicipio] = useState<SGTMunicipioFormValues>(
    new SGTMunicipioFormValues()
  );
  const [SGTComunidad, setSGTComunidad] = useState<SGTComunidadFormValues>(
    new SGTComunidadFormValues()
  );
  const [SGTEntidad, setSGTEntidad] = useState<SGTEntidadFormValues>(
    new SGTEntidadFormValues()
  );
  const [compa, setCompa] = useState("0");

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const validationSchema = Yup.object().shape({
    genero: Yup.string().required("Obligatorio"),
    identidadCultural: Yup.string().required("Obligatorio"),
    comunidadLinguistica: Yup.string().required("Obligatorio"),
    nacionalidad: Yup.string().required("Obligatorio"),
    reMunicipio: Yup.string().required("Obligatorio"),
    proGradoAcademico: Yup.string().required("Obligatorio"),
    labActividadEconomica: Yup.string().required("Obligatorio"),
  });

  useEffect(() => {
    SGPersonaStore.idUser = id
    loadSGTDepartamentos();
    SGTDepartamentoStore.SGTDepartamentoByName.map((item) => {
      const d = {
        text: item.departamento.toString(),
        value: item.idDeparta.toString(),
      };
      Departamentos.push(d);
    });

    loadSGTMunicipios();
    SGTMunicipioStore.SGTMunicipioByName.map((itemmu) => {
      const m = {
        value: itemmu.idMuni.toString(),
        text: itemmu.municipio.toString(),
      };
      Municipios.push(m);
    });

    loadSGTComunidades();
    SGTComunidadStore.SGTComunidadByName.map((itc) => {
      const c = {
        value: itc.idComunidad.toString(),
        text: itc.comunidadLengua.toString(),
      };
      Comunidades.push(c);
    });

    loadSGTEntidades();
    SGTEntidadStore.SGTEntidadByName.map((ite) => {
      const e = {
        value: ite.idEntidad.toString(),
        text: ite.entidad.toString(),
      };
      Entidades.push(e);
    });
  }, [Municipios, Departamentos, Comunidades, Entidades]);



  useEffect(() => {
    cargaPost();
    cambiardepR();
    cambiardepD();
    compas = SGPersona.catDelegacionId;
    if (compas >= 1) {
      dele = "1";
    } else {
      dele = "0"; }
  }, [SGPersona.catDelegacionId, id]);


  useEffect(() => {
    updateLoad();
  }, []);


  const updateLoad = useCallback(() => {
    if (id)
      loadSGPersona(id).then((SGPersona) => {
        setSGPersona(new SGPersonaFormValues(SGPersona));
        persona = SGPersona?.isUpdatedInfo ?? false;
                personal = SGPersona?.dpi ?? false;
        if (personal)
          if (persona == false) return Swal.fire(
            'Actualización de datos necesaria',
            'Por favor, verifica y actualiza la información de tu ficha personal.',
            'warning'
          )
      });
  }, []);

  const cargaPost = useCallback(() => {
    if (id)
      loadSGPersona(id).then((SGPersona) => {
        setSGPersona(new SGPersonaFormValues(SGPersona));
        municipioXdepartamentoLab = [];
        municipioXdepartamentoRe = [];
        persona = SGPersona?.isUpdatedInfo ?? false;
        SGTMunicipioStore.SGTMunicipioByName.map((it) => {
          if (SGPersona?.reDepartamento == it.idMuni.slice(0, 2)) {
            const s = {
              text: it.municipio.toString(),
              value: it.idMuni.toString(),
            };
            municipioXdepartamentoRe.push(s);
          }

          if (SGPersona?.labDepartamento == it.idMuni.slice(0, 2)) {
            const f = {
              text: it.municipio.toString(),
              value: it.idMuni.toString(),
            };
            municipioXdepartamentoLab.push(f);
          }
        });
        if (SGPersona?.labActividadEconomica == "PUB") {
          setActividad(false);
        } else if (SGPersona?.labActividadEconomica == "PRI") {
          setActividad(true);
        }
      });
  }, []);

  function handleFormSubmit(SGPersona: SGPersonaFormValues) {
    if (SGPersona.isUpdatedInfo == false) {
      if (
        dpiValido(SGPersona.dpi) === true &&
        nitValido(SGPersona.nit) === true
      ) {
        SGPersona.isUpdatedInfo = true;
        inpuIns = (document.getElementById("Central") as HTMLInputElement)
          .checked;
        inpuIns2 = (document.getElementById("Petén") as HTMLInputElement)
          .checked;
        inpuIns3 = (document.getElementById("Regional Norte") as HTMLInputElement)
          .checked;
        inpuIns4 = (document.getElementById("Regional Huehuetenango") as HTMLInputElement)
          .checked;

        if (
          (inpuIns === true && inpuIns2 === false && inpuIns3 === false && inpuIns4 === false) ||
          (inpuIns === false && inpuIns2 === false && inpuIns3 === false && inpuIns4 === false)
        ) {
          SGPersona.catDelegacionId = 1;
        } else if (inpuIns === false && inpuIns2 === true && inpuIns3 === false && inpuIns4 === false) {
          SGPersona.catDelegacionId = 2;
        } else if (inpuIns === false && inpuIns2 === false && inpuIns3 === true && inpuIns4 === false) {
          SGPersona.catDelegacionId = 4;
        } else if (inpuIns === false && inpuIns2 === false && inpuIns3 === false && inpuIns4 === true) {
          SGPersona.catDelegacionId = 5;
        } else toast.error("Debes seleccionar una sede o delegación");

        SGPersona.isMigratedUser = false;
        updateSGPersona(SGPersona).then(() => {
          if (localStorage.getItem("check") == "true") {
            toast.success("Datos Actualizados exitosamente 20");
            modalStore.openModal(
              <CodigoInstitucional
                userId={id}
                curso={localStorage.getItem("id_curso")}
                tipo={localStorage.getItem("tipo")}
                monto={localStorage.getItem("cuota")}
                codigoBanco={localStorage.getItem("bancoCodigo")}
                nombreCurso={localStorage.getItem("nombreCurso")}
              />,
              'mini'
            );
          } else {
            history.push(`/home/profile/editar/${user?.id}`);
            toast.success("Datos Actualizados exitosamente 2");
          }
        });
      } else if (
        dpiValido(SGPersona.dpi) === false &&
        nitValido(SGPersona.nit) === false &&
        inpuIns === false &&
        inpuIns2 === false &&
        inpuIns3 === false &&
        inpuIns4 === false
      ) {
        toast.error("DPI, NIT invalido delega");
      } else if (dpiValido(SGPersona.dpi) === false) {
        toast.error("DPI invalido");
      } else if (nitValido(SGPersona.nit) === false) {
        toast.error("NIT invalido");
      } else if (inpuIns === false && inpuIns2 === false && inpuIns3 === false && inpuIns4 === false) {
        toast.error("Debes seleccionar una sede o delegación");
      }
    } else {
      if (
        dpiValido(SGPersona.dpi) === true &&
        nitValido(SGPersona.nit) === true
      ) {
        SGPersona.isUpdatedInfo = true;        
        SGPersona.isMigratedUser = false;
        updateSGPersona(SGPersona).then(() => {
          if (ac === "inscripcion") {
            history.push(`/home/profile/editar/${user?.id}`);
            toast.success("Datos Actualizados exitosamente 3");
          } else {
            history.push(`/home/profile/editar/${user?.id}`);
            toast.success("Datos Actualizados exitosamente 4");
            cambiardepR();
            cambiardepD();
          }
        });
      } else if (
        dpiValido(SGPersona.dpi) === false &&
        nitValido(SGPersona.nit) === false &&
        delegacionValido(SGPersona.catDelegacionId) === false
      ) {
        toast.error("DPI, NIT, y Delegación invalido");
      } else if (inpuIns === false && inpuIns2 === false && inpuIns3 === false && inpuIns4 === false) {
        toast.error("Debes seleccionar una sede o delegación");
      } else if (
        dpiValido(SGPersona.dpi) === false &&
        nitValido(SGPersona.nit) === false
      ) {
        toast.error("DPI y NIT invalido");
      } else if (
        dpiValido(SGPersona.dpi) === false &&
        delegacionValido(SGPersona.catDelegacionId) === false
      ) {
        toast.error("DPI y Delegación invalido");
      } else if (
        nitValido(SGPersona.nit) === false &&
        delegacionValido(SGPersona.catDelegacionId) === false
      ) {
        toast.error("NIT y Delegación invalido");
      } else if (dpiValido(SGPersona.dpi) === false) {
        toast.error("DPI invalido");
      } else if (nitValido(SGPersona.nit) === false) {
        toast.error("NIT invalido");
      }
    }
  }

  function select_acatividad_economica() {
    if (valor() == "PUB") {
      setActividad(false);
    }
    if (valor() == "PRI") {
      setActividad(true);
    }
  }

  function select_departamento_re() {
    municipioXdepartamentoRe = [];
    SGTMunicipioStore.SGTMunicipioByName.map((it) => {
      if (valor() == it.idMuni.slice(0, 2)) {
        const a = {
          text: it.municipio.toString(),
          value: it.idMuni.toString(),
        };
        municipioXdepartamentoRe.push(a);
      }
    });

    var vall = valor();
    const valoress = Departamentos.find(
      (item: { value: any }) => item.value === vall
    );
    valores = valoress.text;
    valores3 = "- Seleccione un Municipio -"
  }

  function select_departamento_lab() {
    municipioXdepartamentoLab = [];
    SGTMunicipioStore.SGTMunicipioByName.map((it) => {
      if (valor() == it.idMuni.slice(0, 2)) {
        const a = {
          text: it.municipio.toString(),
          value: it.idMuni.toString(),
        };
        municipioXdepartamentoLab.push(a);
      }
    });
    if (valor() === "") {

    } else {
      var vall2 = valor();
      const valoress2 = Departamentos.find(
        (item2: { value: any }) => item2.value === vall2
      );
      valores2 = valoress2.text;
      valores4 = "- Seleccione un Municipio -"
    }
  }

  function delegacion_guardada() {
    if (SGPersona.catDelegacionId != 0) {
      return true;
    } else {
      return false;
    }
  }

  function dpi_guardado() {
    if (!SGPersona.dpi) {
      return false;
    }
    return true;
  }

  const [delegacionOp, setDelegacion] = useState("");

  const handleChangeDl = (e: any) => {
    setDelegacion(e.target.id);
  };

  function cambiardepR() {
    if (SGPersona.reDepartamento === "") {
    } else {
      Departamentos.map((item: any) => {
        const dep = SGPersona?.reDepartamento;
        const valoress = Departamentos.find(
          (item: { value: any }) => item.value === dep
        );
        valores = valoress.text;
      });

      Municipios.map((item: any) => {
        const dep = SGPersona?.reMunicipio;
        const valoress = Municipios.find(
          (item: { value: any }) => item.value === dep
        );
        valores3 = valoress.text;
      });
    }
  }

  function cambiardepD() {
    if (SGPersona.labDepartamento === "") {
    } else {

      Departamentos.map((item2: any) => {
        const dep2 = SGPersona.labDepartamento;
        const valoress2 = Departamentos.find(
          (item2: { value: any }) => item2.value === dep2
        );
        valores2 = valoress2.text;
      });

      Municipios.map((item: any) => {
        const dep = SGPersona.labMunicipio;
        const valoress = Municipios.find(
          (item: { value: any }) => item.value === dep
        );
        valores4 = valoress.text;
      });
    }
  }

  // const IsUpdated = () => {
  //   if (SGPersona.isUpdatedInfo == false ) {
  //     return (
  //       Swal.fire({
  //         position: "center",
  //         icon: "warning",
  //         title: "Actualización de datos necesaria",
  //         text: "Por favor, verifica y actualiza la información de tu ficha personal.",
  //         showConfirmButton: false,
  //         timer: 3500,
  //       })
  //     )
  //   }
  // };

  function delegacion_logic() {
    if (SGPersona.catDelegacionId === 1) {
      return (
        <>
          <div className="accordion-delegacion-description">
            <p>Tu centro de capacitación es:</p>
            <hr />
          </div>
          <div className="delegacion_seleccion">
            <img src={modalRCentral} alt="Delegación Central" />
            <p>INAP Central</p>
          </div>
          <div className="accordion-delegacion-description">
            <span>
              Ya has seleccionado tu centro de capacitación y esta opción no se
              puede cambiar. <br></br>Para hacerlo necesitas comunicarte a
              nuestra línea de atención
            </span>
          </div>
        </>
      );
    } else if (SGPersona.catDelegacionId === 2) {
      return (
        <>
          <div className="accordion-delegacion-description">
            <p>Tu centro de capacitación es:</p>
            <hr />
          </div>
          <div className="delegacion_seleccion">
            <img src={modalRPeten} alt="Delegación Central" />
            <p>INAP Petén</p>
          </div>
          <div className="accordion-delegacion-description">
            <span>
              Ya has seleccionado tu centro de capacitación y esta opción no se
              puede cambiar. <br></br>Para hacerlo necesitas comunicarte a
              nuestra línea de atención
            </span>
          </div>
        </>
      );
    } else if (SGPersona.catDelegacionId === 4) {
      return (
        <>
          <div className="accordion-delegacion-description">
            <p>Tu centro de capacitación es:</p>
            <hr />
          </div>

          <div className="delegacion_seleccion">
            <img src={modalRegNorte} alt="Delegación Central" />
            <p>INAP Regional Norte</p>
          </div>

          <div className="accordion-delegacion-description">
            <span>
              Ya has seleccionado tu centro de capacitación y esta opción no se
              puede cambiar. <br></br>Para hacerlo necesitas comunicarte a
              nuestra línea de atención
            </span>
          </div>
        </>
      );
    } else if (SGPersona.catDelegacionId === 5) {
      return (
        <>
          <div className="accordion-delegacion-description">
            <p>Tu centro de capacitación es:</p>
            <hr />
          </div>
          <div className="delegacion_seleccion">
            <img src={modalRegHuehue} alt="Delegación Central" />
            <p>INAP Huehuetenango</p>
          </div>
          <div className="accordion-delegacion-description">
            <span>
              Ya has seleccionado tu centro de capacitación y esta opción no se
              puede cambiar. <br></br>Para hacerlo necesitas comunicarte a
              nuestra línea de atención
            </span>
          </div>
        </>
      );
    } else if (
      SGPersona.catDelegacionId === 0 ||
      SGPersona.catDelegacionId === null ||
      SGPersona.catDelegacionId === undefined ||
      SGPersona.catDelegacionId === 6
    ) {
      return (
        <>
          <div className="accordion-delegacion-description">
            <p>Selecciona tu centro de capacitación.</p>
          </div>

          <ToggleButtonGroup
            type="radio"
            name="catDelegacionId"
            defaultValue={SGPersona.catDelegacionId}
          >
            <ToggleButton
              className="Delegación Central"
              id="Central"
              value={1}
              disabled={delegacion_guardada()}
              active={true}
              variant="primary"
              onChange={handleChangeDl}
            >
              <div className="fondo-select-delegacion"></div>
              <img src={modalRCentral} alt="Delegación Central" />
              <p>Central</p>
            </ToggleButton>
            <ToggleButton
              className="Delegación Petén"
              id="Petén"
              value={2}
              disabled={delegacion_guardada()}
              active={true}
              variant="secondary"
              onChange={handleChangeDl}
            >
              <div className="fondo-select-delegacion"></div>
              <img src={modalRPeten} alt="Delegación Petén" />
              <p>Petén</p>
            </ToggleButton>
            <ToggleButton
              className="Delegación Regional Norte"
              id="Regional Norte"
              value={4}
              disabled={delegacion_guardada()}
              active={true}
              variant="secondary"
              onChange={handleChangeDl}
            >
              <div className="fondo-select-delegacion"></div>
              <img src={modalRegNorte} alt="Delegación Regional Norte" />
              <p>Regional Norte</p>
            </ToggleButton>
            <ToggleButton
              className="Delegación Regional Huehuetenango"
              id="Regional Huehuetenango"
              value={5}
              disabled={delegacion_guardada()}
              active={true}
              variant="secondary"
              onChange={handleChangeDl}
            >
              <div className="fondo-select-delegacion"></div>
              <img src={modalRegHuehue} alt="Delegación Regional Huehuetenango" />
              <p>Huehuetenango</p>
            </ToggleButton>
          </ToggleButtonGroup>

          <div className="seleccion_delegacion">
            <p>
              <span>Has2 seleccionado la sede: {delegacionOp}</span>
            </p>
          </div>
          <div className="accordion-delegacion-description">
            <span>
              Esta opción no se podrá cambiar. <br></br>Para hacerlo deberás
              comunicarte a nuestra línea de atención.
            </span>
          </div>
        </>
      );
    }
  }

  const open = Boolean(anchorEl);

  const FechaNacimiento = SGPersona.fechaNacimiento + " 00:00:00";

  if (loadingInitial)
    return <LoadingComponent content="Cargando datos de personas..." />;
  return (

    <>
      {/* { SGPersona.isUpdatedInfo ? console.log("SGP", SGPersona.isUpdatedInfo) : IsUpdated()} */}

      <div>
        <Formik
          validationSchema={validationSchema}
          enableReinitialize
          initialValues={SGPersona}
          onSubmit={(values) => handleFormSubmit(values)}
        >
          {({
            handleSubmit,
            handleChange,
            isSubmitting,
            errors,
            isValid,
            dirty,
          }) => (
            <Form className="" onSubmit={handleSubmit} autoComplete="off">
              <Container className="ficha-cuerpo">
                <Row>
                  <Col xl={4} className="sidebar">
                    <h3>Edita tu perfil</h3>
                    <div className="img-avatar">
                      <img src={user?.image || userPlaceholder} />
                    </div>
                    <IconButton className="pic-profile-button">
                      <Link
                        to={`/home/profile/${user?.userName}/${user?.id}/Fotos`}
                        onMouseOver={() => { }}
                      >
                        <EditIcon fontSize="large" />
                      </Link>
                      <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        classes={{
                          paper: classes.paper,
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "center",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "center",
                          horizontal: "center",
                        }}
                        disableRestoreFocus
                      >
                        <Typography>Cambiar foto de perfil</Typography>
                      </Popover>
                    </IconButton>

                    <h4>{user?.displayName}</h4>
                    <h5>{user?.email}</h5>
                    <span className={"actualizarContraseña"} onClick={() => modalStore.openModal(<ActualizarContraseña userId={""} />, 'mini')}>Actualizar contraseña</span>

                    <span className="sidebar-division"></span>

                    <div className="buttons-area">
                      <Link
                        to={`/home/profile/${user?.userName}/${user?.id}/SaldosPendientes`}
                      >
                        <Button variant="primary">Saldos pendientes</Button>
                        {""}
                      </Link>
                      <Link
                        to={`/home/profile/${user?.userName}/${user?.id}/Recibos`}
                      >
                        <Button variant="primary">Recibos generados</Button>{" "}
                      </Link>
                      <Link to={`/home/profile/${user?.userName}/${user?.id}/Notas`}>
                        <Button variant="primary">Mis notas</Button>{" "}
                      </Link>
                    </div>
                    <div className="area-blanco"></div>
                  </Col>

                  <Col xl={8} className="form-area">
                    <Form.Group>
                      <Accordion defaultActiveKey={dele}>
                        <Accordion.Item eventKey="0" className="accordion-alert">
                          <Accordion.Header>1.- Delegación</Accordion.Header>
                          <Accordion.Body>
                            <div className="accordion-contenedor accordion-delegacion">
                              <div>{delegacion_logic()}</div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            2.- Datos Personales
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="accordion-contenedor">
                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="Nombres"
                                >
                                  <Form.Label>Nombres</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="nombres"
                                    placeholder="Ingresa tus nombres"
                                    onChange={handleChange}
                                    defaultValue={SGPersona.nombres}
                                  />
                                </Form.Group>

                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="Apellidos"
                                >
                                  <Form.Label>Apellidos</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Ingresa tus apellidos"
                                    name="apellidos"
                                    onChange={handleChange}
                                    defaultValue={SGPersona.apellidos}
                                  />
                                </Form.Group>
                              </Row>

                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>DPI</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="dpi"
                                    placeholder="000000000000"
                                    defaultValue={SGPersona.dpi}
                                    onChange={handleChange}
                                    disabled={dpi_guardado()}
                                  />
                                </Form.Group>

                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="nit"
                                >
                                  <Form.Label>NIT</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="nit"
                                    placeholder="000000000"
                                    onChange={handleChange}
                                    defaultValue={SGPersona.nit}
                                  />
                                </Form.Group>
                              </Row>

                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="fechaNacimiento"
                                >
                                  <Form.Label>Fecha de nacimiento</Form.Label>
                                  <Form.Control
                                    type="date"
                                    name="fechaNacimiento"
                                    onChange={handleChange}
                                    defaultValue={calculoFechasControl(
                                      new Date(FechaNacimiento || "")
                                    )}
                                    key={calculoFechasControl(
                                      new Date(FechaNacimiento || "")
                                    )}
                                  />
                                </Form.Group>

                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>Nacionalidad</Form.Label>
                                  <MySelectInputControl
                                    id="nacionalidad"
                                    name="nacionalidad"
                                    placeholder={
                                      SGPersona.nacionalidad
                                        ? SGPersona.nacionalidad
                                        : "- Selecciona una opción -"
                                    }
                                    options={NacionalidadOptions}
                                  />
                                </Form.Group>
                              </Row>

                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>Identidad cultural</Form.Label>
                                  <MySelectInputControl
                                    id="identidadCultural"
                                    name="identidadCultural"
                                    placeholder={
                                      SGPersona.identidadCultural
                                        ? SGPersona.identidadCultural
                                        : "- Selecciona una opción -"
                                    }
                                    options={IdentidadCulturalOptions}
                                  />
                                </Form.Group>

                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>Comunidad lingüistica</Form.Label>
                                  <MySelectInputControl
                                    id="comunidadLinguistica"
                                    name="comunidadLinguistica"
                                    placeholder={
                                      SGPersona.comunidadLinguistica
                                        ? SGPersona.comunidadLinguistica
                                        : "- Selecciona una opción -"
                                    }
                                    options={Comunidades}
                                    key={SGPersona.comunidadLinguistica}
                                  />
                                </Form.Group>
                              </Row>

                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>Género</Form.Label>
                                  <MySelectInputControl
                                    id="genero"
                                    name="genero"
                                    placeholder={
                                      SGPersona.genero
                                        ? SGPersona.genero
                                        : "- Selecciona una opción -"
                                    }
                                    options={GeneroOptions}
                                  />
                                </Form.Group>
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="celular"
                                >
                                  <Form.Label>
                                    Número de teléfono celular
                                  </Form.Label>
                                  <Form.Control
                                    type="number"
                                    placeholder="0000 0000"
                                    name="celular"
                                    onChange={handleChange}
                                    defaultValue={SGPersona.celular}
                                  />
                                </Form.Group>
                              </Row>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                          <Accordion.Header>
                            3.- Ubicación Geográfica
                          </Accordion.Header>
                          <Accordion.Body id="Geo">
                            <div className="accordion-contenedor">
                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>Departamento</Form.Label>

                                  <MySelectInputEdicionesControl
                                    functionevent={select_departamento_re}
                                    id="reDepartamento"
                                    name="reDepartamento"
                                    placeholder={
                                      SGPersona.reDepartamento
                                        ? valores
                                        : "- Selecciona una opción -"
                                    }
                                    options={Departamentos}
                                  />
                                </Form.Group>

                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>Municipio</Form.Label>

                                  <MySelectInputControl
                                    id="reMunicipio"
                                    name="reMunicipio"
                                    placeholder={
                                      SGPersona.reMunicipio
                                        ? valores3
                                        : "- Selecciona una opción -"
                                    }
                                    options={municipioXdepartamentoRe}

                                  />
                                </Form.Group>
                              </Row>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                          <Accordion.Header>
                            4.- Información Académica
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="accordion-contenedor">
                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="formGridInput"
                                >
                                  <Form.Label>Grado académico</Form.Label>
                                  <MySelectInputControl
                                    id="proGradoAcademico"
                                    name="proGradoAcademico"
                                    placeholder={
                                      SGPersona.proGradoAcademico
                                        ? SGPersona.proGradoAcademico
                                        : "- Selecciona una opción -"
                                    }
                                    options={GradoAcademicoOptions}
                                  />
                                </Form.Group>

                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="proProfesionUOficio"
                                >
                                  <Form.Label>Profesión u oficio</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Ingresa tu profesión"
                                    name="proProfesionUOficio"
                                    onChange={handleChange}
                                    defaultValue={SGPersona.proProfesionUOficio}
                                  />
                                </Form.Group>
                              </Row>

                              <Row className="mb-3">
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="proColegioProfesional"
                                >
                                  <Form.Label>Colegio profesional</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Ingresa tu colegio profesional"
                                    onChange={handleChange}
                                    defaultValue={SGPersona.proColegioProfesional}
                                    name="proColegioProfesional"
                                  />
                                </Form.Group>
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  md={6}
                                  controlId="proNumeroColegiado"
                                >
                                  <Form.Label>Número de colegiado</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="0000 0000"
                                    onChange={handleChange}
                                    defaultValue={SGPersona.proNumeroColegiado}
                                    name="proNumeroColegiado"
                                  />
                                </Form.Group>
                              </Row>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                          <Accordion.Header>
                            5.- Información Laboral
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="accordion-contenedor">
                              <Row className="mb-3">
                                {actividad ? (
                                  <>
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Actividad económica</Form.Label>
                                      <MySelectInputEdiciones
                                        id="labActividadEconomica"
                                        name="labActividadEconomica"
                                        placeholder={
                                          SGPersona.labEmpresa
                                            ? SGPersona.labEmpresa
                                            : "- Selecciona -"
                                        }
                                        options={ActividadEconomicaOptions}
                                        functionevent={
                                          select_acatividad_economica
                                        }
                                      />
                                    </Form.Group>

                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="labEmpresa"
                                    >
                                      <Form.Label>Empresa</Form.Label>
                                      <Form.Control
                                        id="Empresa"
                                        type="text"
                                        name="labEmpresa"
                                        placeholder={
                                          SGPersona.labEmpresa
                                            ? SGPersona.labEmpresa
                                            : "Ingresa el nombre de la empresa"
                                        }
                                        onChange={handleChange}
                                        defaultValue={SGPersona.labEmpresa}
                                      />
                                    </Form.Group>
                                  </>
                                ) : (
                                  <>
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Actividad económica</Form.Label>
                                      <MySelectInputEdiciones
                                        id="labActividadEconomica"
                                        name="labActividadEconomica"
                                        placeholder={
                                          SGPersona.labEmpresa
                                            ? SGPersona.labEmpresa
                                            : "- Selecciona -"
                                        }
                                        options={ActividadEconomicaOptions}
                                        functionevent={
                                          select_acatividad_economica
                                        }
                                      />
                                    </Form.Group>

                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Entidad</Form.Label>
                                      <MySelectInputControl
                                        id="labEntidad"
                                        name="labEntidad"
                                        placeholder={
                                          SGPersona.labEntidad
                                            ? SGPersona.labEntidad
                                            : "- Selecciona una opción -"
                                        }
                                        options={InstitucionesPublicas}
                                        key={SGPersona.labEntidad}
                                      />
                                    </Form.Group>
                                  </>
                                )}
                              </Row>

                              {actividad ? (
                                <>
                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Departamento</Form.Label>
                                      <MySelectInputEdicionesControll
                                        functionevent={select_departamento_lab}
                                        id="labDepartamento"
                                        name="labDepartamento"
                                        placeholder={
                                          SGPersona.labDepartamento
                                            ? valores2
                                            : "- Selecciona una opción -"
                                        }
                                        options={Departamentos}
                                      />
                                    </Form.Group>

                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Municipio</Form.Label>
                                      <MySelectInputControl
                                        id="labMunicipio"
                                        name="labMunicipio"
                                        placeholder={
                                          SGPersona.labMunicipio
                                            ? valores4
                                            : "- Selecciona una opción -"
                                        }
                                        options={municipioXdepartamentoLab}
                                      />
                                    </Form.Group>
                                  </Row>
                                </>
                              ) : (
                                <>
                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="labDependencia"
                                    >
                                      <Form.Label>Dependencia</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="labDependencia"
                                        placeholder={
                                          SGPersona.labDependencia
                                            ? SGPersona.labDependencia
                                            : "- Ingrese su dependencia -"
                                        }
                                        defaultValue={SGPersona.labDependencia}
                                        onChange={handleChange}
                                      />
                                    </Form.Group>
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="labPuestoFuncional2"
                                    >
                                      <Form.Label>Puesto funcional</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="labPuestoFuncional"
                                        onChange={handleChange}
                                        placeholder={
                                          SGPersona.labPuestoFuncional
                                            ? SGPersona.labPuestoFuncional
                                            : "Ej: Departamento de reclutamiento"
                                        }
                                        defaultValue={
                                          SGPersona.labPuestoFuncional
                                        }
                                      />
                                    </Form.Group>
                                  </Row>

                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Departamento</Form.Label>
                                      <MySelectInputEdicionesControll
                                        functionevent={select_departamento_lab}
                                        id="labDepartamento"
                                        name="labDepartamento"
                                        placeholder={
                                          SGPersona.labDepartamento
                                            ? valores2
                                            : "- Selecciona una opción -"
                                        }
                                        options={Departamentos}
                                      />
                                    </Form.Group>

                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Municipio</Form.Label>
                                      <MySelectInputControl
                                        id="labMunicipio"
                                        name="labMunicipio"
                                        placeholder={
                                          SGPersona.labMunicipio
                                            ? valores4
                                            : "- Selecciona una opción -"
                                        }
                                        options={municipioXdepartamentoLab}
                                      />
                                    </Form.Group>
                                  </Row>
                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      md={6}
                                      controlId="formGridInput"
                                    >
                                      <Form.Label>Renglón</Form.Label>
                                      <MySelectInputControl
                                        id="labRenglon"
                                        name="labRenglon"
                                        placeholder={
                                          SGPersona.labRenglon
                                            ? SGPersona.labRenglon
                                            : "- Selecciona una opción -"
                                        }
                                        options={RenglonesPersonasOptions}
                                      />
                                    </Form.Group>
                                  </Row>
                                </>
                              )}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </Form.Group>
                    <div className="form-footer">
                      <Button
                        disabled={SGPersonaStore.loading}
                        loading={SGPersonaStore.loading}
                        variant="primary"
                        type="submit"
                        content="Guardar"
                      />
                    </div>
                  </Col>
                </Row>
              </Container>
            </Form>
          )}
        </Formik>

        <Footer />
      </div>
    </>
  );
});
